// extracted by mini-css-extract-plugin
module.exports = {"header":"product-content-module--header--34_a7","text":"product-content-module--text--1-lED"};